import { render, staticRenderFns } from "./Especialidades.vue?vue&type=template&id=5e23b04b&scoped=true"
import script from "./Especialidades.vue?vue&type=script&lang=js"
export * from "./Especialidades.vue?vue&type=script&lang=js"
import style0 from "./Especialidades.vue?vue&type=style&index=0&id=5e23b04b&prod&lang=stylus&scoped=true"
import style1 from "./Especialidades.vue?vue&type=style&index=1&id=5e23b04b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e23b04b",
  null
  
)

export default component.exports